import type { TAdvancePaymentCalculatorForm } from '../../types'

export const DEFAULT_ADVANCE_PAYMENT_CALCULATOR_ADVANCE_AMOUNT = 10_000_000
export const ADVANCE_PAYMENT_CALCULATOR_FORM_INITIAL_VALUES: Readonly<Partial<TAdvancePaymentCalculatorForm>> = {
  advanceAmount: DEFAULT_ADVANCE_PAYMENT_CALCULATOR_ADVANCE_AMOUNT,
  advancePaymentDate: null,
  elevator: null,
  productDeliveryDate: null,
}

export const ADVANCE_PAYMENT_CALCULATOR_FORM_SUBMIT_DEBOUNCE_TIME = 500
